export default {
  USD: '$',
  EUR: '€',
  AED: 'د.إ',
  ALL: 'LEK',
  AMD: 'Դ',
  ARS: 'AR$',
  AUD: 'A$',
  AZN: '₼',
  BDT: '৳',
  BGN: 'Лв',
  BMD: 'BD$',
  BRL: 'R$',
  CAD: 'C$',
  CDF: 'FC',
  CHF: '₣',
  CLP: 'CLP$',
  CNY: '¥',
  COP: 'COP$',
  CRC: '₡',
  CZK: 'Kč',
  DKK: 'Kr.',
  GBP: '£',
  GEL: '₾',
  GHS: 'GH¢',
  GTQ: 'Q',
  HKD: 'HK$',
  HRK: 'kn‎',
  HTG: 'G',
  HUF: 'Ft',
  IDR: 'Rp',
  ILS: '₪',
  INR: '₹',
  IQD: 'ع.د',
  IRR: '﷼',
  ISK: 'Íkr',
  JPY: '¥‎',
  KES: 'KSh',
  KGS: 'KGS',
  KRW: '₩',
  KWD: 'د.ك',
  KYD: 'KY$',
  KZT: '₸',
  MAD: 'MAD',
  MDL: 'L',
  MKD: 'Ден',
  MMK: 'K',
  MNT: '₮',
  MXN: 'Mex$',
  MYR: 'RM',
  NAD: 'N$',
  NGN: '₦',
  NOK: 'kr',
  NZD: 'NZ$',
  PEN: 'S/',
  PLN: 'zł',
  PYG: '₲',
  RON: 'lei',
  RUB: '₽',
  SAR: '﷼‎',
  SEK: 'kr',
  SGD: 'S$',
  SLL: 'Le',
  THB: '฿',
  TMT: 'T',
  TND: 'د.ت',
  TRY: '₺',
  TWD: 'NT$',
  TZS: 'TSh',
  UAH: '₴',
  UGX: 'USh',
  UYU: '$U',
  UZS: "so'm",
  VND: '₫',
  XAF: 'FCFA',
  XOF: 'CFA',
  ZAR: 'R',
  ZMW: 'ZK',
  BAM: 'KM',
  PHP: '₱',
  BYN: 'BYN',
  ETB: 'ብር',
  PKR: 'Rs',
  EGP: '£',
  KHR: '₭',
  LAK: '₭',
  MVR: 'Rf',
  TJS: 'TJS',
  SOS: 'SOS',
  SDG: 'SDG',
  IRT: 'IRT',

  //   Cryptocurrency
  BTC: 'BTC',
  mBTC: 'mBTC',
  MBC: 'mBTC',
  MBT: 'mBT',
  ETH: 'ETH',
  mETH: 'mETH',
  LTC: 'LTC',
  DOG: 'DOG',
  DOGE: 'DOGE',
  XDG: 'XDG',
  USDT: 'USDT',
  USDC: 'USDC',
  BNB: 'BNB',
  FTN: 'FTN',
}
